var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourheadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 16,
    viewBox: "0 0 198 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9315V0H22.3041V3.1863H3.1863V6.3726H22.3041V9.5589H3.1863V15.9315H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0596 15.9315V9.5589H97.2459V15.9315H94.0596ZM74.9418 15.9315V0H97.2459V6.3726H94.0596V3.1863H78.1281V6.3726H94.0596V9.5589H78.1281V15.9315H74.9418Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8424 14.3511H26.5625V1.59275H49.4456V14.3511H70.6736V0",
    stroke: "#00CEC8",
    strokeWidth: 3.17355
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9219 15.9315V0H103.108V6.3726H119.04V0H122.226V15.9315H119.04V9.5589H103.108V15.9315H99.9219Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.902 15.9315V0H147.207V3.1863H128.089V6.3726H147.207V9.5589H128.089V12.7452H147.207V15.9315H124.902Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.001 6.3726V3.1863H153.069V6.3726H169.001ZM149.883 15.9315V0H172.187V15.9315H169.001V9.5589H153.069V15.9315H149.883Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.981 12.7452V3.1863H197.168V12.7452H193.981ZM174.864 15.9315V0H193.981V3.1863H178.05V12.7452H193.981V15.9315H174.864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourheadLogo);
export default __webpack_public_path__ + "static/media/fourhead-logo.06dd35d925d44260b8b240af704bc68a.svg";
export { ForwardRef as ReactComponent };